import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import Icon from '../../../components/AppIcon';


export default function DraggableBlock({ id, block, isAvailable }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS?.Transform?.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const Icon = block?.icon;

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`group flex items-center gap-3 p-3 rounded-lg border cursor-move transition-all ${
        isAvailable
          ? 'border-gray-200 hover:border-indigo-500 hover:bg-indigo-50' :'border-gray-300 bg-white shadow-sm'
      }`}
    >
      <GripVertical className="w-4 h-4 text-gray-400 group-hover:text-indigo-600" />
      {Icon && <Icon className="w-5 h-5 text-gray-600 group-hover:text-indigo-600" />}
      <span className="text-sm font-medium text-gray-700 group-hover:text-indigo-900">
        {block?.label}
      </span>
    </div>
  );
}